
  /**
   * Simple CSV to JSON parser for comma-separated values.
   * Assumes first row is header.
   */
  export function csvToJson(csv: string, separator: string = ','): any[] {
    const lines = csv.split(/\r?\n|\r|\n/g).filter(line => line.trim().length > 0);
    if (lines.length < 2) return [];
    const headers = lines[0].split(separator).map(h => h.trim());
    return lines.slice(1).map(line => {
      const values = line.split(separator).map(v => v.trim());
      const obj: any = {};
      headers.forEach((h, i) => obj[h] = values[i]);
      return obj;
    });
  }
